import React, { Component } from 'react';
import RangeDatePicker from '@webthatmatters/react-range-datepicker';
import SvgRender from 'components/helpers/SvgRender';
import moment from 'moment';
import calendar from 'assets/svg/calendar.svg';
import application from 'assets/svg/application.svg';
import Select from 'components/inputs/Select';

class Filters extends Component {
  onDatesChange = dates => {
    if (dates.from && dates.to) {
      this.props.onChange({
        from: dates.from.format('YYYY-MM-DD'),
        to: dates.to.format('YYYY-MM-DD')
      });
    }
  };

  render() {
    let options = this.props.integrations.map(intergration => {
      return { value: intergration.id, label: intergration.name };
    });

    return (
      <div className="d-flex">
        <div className="date-wraper">
          <RangeDatePicker
            styles={{
              selectedColor: '#007aff',
              calendarIcon: calendar
            }}
            dates={{ from: moment(this.props.dates.from), to: moment(this.props.dates.to) }}
            onDatesChange={this.onDatesChange}
            showOptions
          />
        </div>
        <div className="app-select d-flex ml-7">
          <SvgRender path={application} style={{ height: 22 }} />
          <Select
            options={options}
            isMulti={true}
            placeholder="Select Application(s)"
            onChange={this.props.intergrationOnChange}
          />
        </div>
      </div>
    );
  }
}

export default Filters;



// WEBPACK FOOTER //
// ./src/views/channels/Filters.js